/** Traductions boîte de dialogue de confirmation (FR / AR) */
export const confirmDialogFr = {
  defaultTitle: 'Confirmer l\'action',
  defaultMessage: 'Êtes-vous sûr de vouloir continuer ?',
  confirm: 'Confirmer',
  cancel: 'Annuler'
};

export const confirmDialogAr = {
  defaultTitle: 'تأكيد الإجراء',
  defaultMessage: 'هل أنت متأكد من أنك تريد المتابعة؟',
  confirm: 'تأكيد',
  cancel: 'إلغاء'
};
